export default __webpack_public_path__ + "static/tooltip-interactive-1-dont-dark-4239eef129f323b6d3fa6747ec5ad85e.png";